"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiredRightsAbsenceManagementSetting = void 0;
const models_1 = require("../models");
// users can set absence management settings if they have any of these rights
exports.requiredRightsAbsenceManagementSetting = [models_1.RightEnum.EXPENSE__BASIC__APPROVE];
